<template>
    <b-card class="feed-item mb-3">
        <b-btn-group class="action-buttons" v-if="!forExport">
            <b-btn v-if="documentId"
                class="action-icon"
                v-b-tooltip.hover
                :title="$t('feed.actionButtons.goToFile')"
                @click.stop="goToFile(feedData.relatedDocuments[0])">
                <icon name="file" scale="0.9"></icon>
            </b-btn>
            <b-btn  v-show="projectPermissions.includes('UPDATE_MESSAGE') && showEditDeleteButtons"
                    class="action-icon"
                    v-b-tooltip.hover
                    :title="$t('feed.actionButtons.editMessage')"
                    @click.stop="showMessageModal = true">
                <icon name="pencil" scale="0.9"></icon>
            </b-btn>
            <b-btn  v-show="projectPermissions.includes('DELETE_MESSAGE') && showEditDeleteButtons"
                    class="action-icon"
                    v-b-tooltip.hover
                    :title="$t('feed.actionButtons.deleteMessage')"
                    @click="deleteMessage(feedData.id)">
                <icon name="trash" scale="0.9"></icon>
            </b-btn>
        </b-btn-group>
        <b-media>
            <b-row v-bind:class="[forExport ? 'header-row-export' : 'header-row']">
                <b-col v-if="!forExport">
                    <avatar v-if="collaborator" :username="collaborator.displayName"
                            :size="32"
                            :inline="true"
                            class="avatar">
                    </avatar>
                </b-col>
                <b-col v-else>
                    <span class="mb-0 m-2">{{ setFeedItemMessage(feedData) }}</span>
                </b-col>
                <b-col class="text-right">
                    <h6 class="mb-0">
                        <small v-if="collaborator" class="text-muted mr-1">{{ collaborator.displayName }}</small>
                        <small v-if="collaborator && collaborator.duplicate" class="text-muted"><em>({{ collaborator.email }})</em></small>
                        <small class="text-muted ml-2">
                            <em>{{ feedData.created.substring(0, feedData.created.length - 1) | fromNow }}</em> <br>
                            <small v-if="feedData.lastEditDate">
                                ({{ $t('feed.updated') }} <em>{{ feedData.lastEditDate.substring(0, feedData.lastEditDate.length - 1) | formatDateTimeNoSec }}</em>)
                            </small>
                        </small>
                    </h6>
                </b-col>
            </b-row>
            <b-row v-if="!forExport" class="pt-3">
                <b-col>
                    <span class="mb-0 m-2">{{ setFeedItemMessage(feedData) }}</span>
                </b-col>
                <b-col cols="3"></b-col>
            </b-row>
        </b-media>

        <b-modal v-model="showMessageModal"
                 :title="$t('feed.editMessage.name')"
                 header-bg-variant="secondary"
                 header-text-variant="white"
                 :ok-title="$t('feed.editMessage.create')"
                 ok-variant="outline-info"
                 :cancel-title="$t('general.cancel')"
                 cancel-variant="outline-secondary"
                 centered
                 no-fade
                 no-close-on-esc
                 no-close-on-backdrop
                 hide-header-close
                 @ok.prevent="editMessage"
                 @shown="onNewMessageModalShown">
            <new-message-form :file="feedData" :hide-button="true" @closeMessageForm="onCloseMessageForm" ref="editMessageModal"></new-message-form>
        </b-modal>
    </b-card>
</template>

<script>
    import Avatar from 'vue-avatar';
    import { mapGetters } from 'vuex';
    import NewMessageForm from '../../../Shared/NewMessageForm';

    export default {
        props: [
            'feedData', 'forExport'],

        components: {
            Avatar,
            NewMessageForm
        },
        
        data() {
            return {
                showMessageModal: false
            }
        },
        
        computed: {
            ...mapGetters({
                projectData: 'projects/projectData'
            }),

            collaborator() {
                let userId = this.feedData.authorId;
                let user = this.$store.getters['projects/projectCollaborator'](userId);
                return user;
            },

            documentId() {
                if (this.feedData.relatedDocuments)
                    return (this.feedData.relatedDocuments[0]);
            },

            showEditDeleteButtons() {
                let { authorId } = this.feedData;
                let userId = this.$store.state.userData.data.id;
                if (this.feedData.type.toUpperCase() === 'MESSAGE' && authorId === userId) {
                    return true;
                } else {
                    return false;
                }
            },
            projectPermissions() {
              if(this.$store.state.projects.currentProject.projectData.role){
                return this.$store.state.projects.currentProject.projectData.role.permissions;
              } else {
                return [];
              }
            },
        },
        
        methods: {

            setFeedItemMessage(item) {
                if(item.type.toUpperCase() === 'NOTIFICATION') {
                    switch (item.content) {
                        case 'share_link_created': {
                            if (item.title) {
                                let formatedDate = this.$options.filters.formatDate(item.title);
                                return this.$i18n.t('feed.shareLinkValid', { date: formatedDate});
                            } else {
                                return this.$i18n.t('feed.shareLinkNotActive');
                            }
                        }
                        case 'new_project_member': {
                            let userName = this.collaborator ? this.collaborator.displayName : '';
                            let projectName = this.projectData.name;
                            return this.$i18n.t('feed.newProjectMemberMessage', { userName, projectName });
                        }
                    }
                } else {
                    return item.content
                }
            },

            goToFile(fileId) {
                this.$router.push({
                    name: 'project-files',
                    params: { 
                        projectId: this.$route.params.projectId, 
                        fileId: fileId
                    },
                    query: {
                        displayFileId: fileId
                    }
                });
            },

            deleteMessage(messageId) {
                let { projectId } = this.$route.params;
                const deleteMessageAction = () => {
                    this.$store.dispatch('projects/removeFeedItem', {
                        projectId, 
                        itemId: messageId
                    });
                }

                this.$snotify.confirm(this.$i18n.t('general.promptQuestion'), '', {
                    closeOnClick: true,
                    backdrop: 0.3,
                    buttons: [
                        {text: this.$i18n.t('general.yes'), action: deleteMessageAction},
                        {text: this.$i18n.t('general.no')}
                    ]
                });
            },

            editMessage() {
                this.$refs.editMessageModal.updateMessage();
            },

            onCloseMessageForm() {
                this.showMessageModal = false;
            },

            onNewMessageModalShown() {
                this.$refs.editMessageModal.$validator.reset();
                this.$refs.editMessageModal.newMessage.id = this.feedData.id;
                this.$refs.editMessageModal.newMessage.content = this.feedData.content;
            },
        }
    }
</script>


<style lang="scss" scoped>
    .feed-item {
        .action-buttons {
            top: 0;
            right: 0;
            z-index: 50;
            position: absolute;

            .action-icon {
                padding: 0 3px;
            }
        }
    }

    .header-row {
        border-bottom: 1px solid #e5e5e5;
        padding: 1rem 0;
        margin-top: -1rem;
        align-items: center;
        display: flex;
        align-items: center;
    }

    .header-row-export {
        border-bottom: none !important;
        padding: 1rem 0;
        margin-top: -1rem;
        align-items: center;
        display: flex;
        align-items: center;
    }
</style>
